import { useQuery } from 'react-query';
import { authFetch } from '../../../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

export interface SocialSecurityComparisonModel {
  Strategy: string;
  ProbabilityOfSuccess: number | null;
  BenefitStartAgePrincipal: number | null;
  BenefitStartAgeSpouse: number | null;
  FirstYearBenefitPrincipal: number | null;
  FirstYearBenefitSpouse: number | null;
  TotalLifetimeBenefitPrincipal: number | null;
  TotalLifetimeBenefitSpouse: number | null;
  RetirementAssetsAtEndOfPlan: number | null;
  NetWorthAtEndOfPlan: number | null;
  BreakevenAgePrincipal: number | null;
  BreakevenAgeSpouse: number | null;
  CanApply: boolean;
  IsApplied: boolean;
}

export interface SocialSecurityComparisonDTO {
  ActivePlan: SocialSecurityComparisonModel | null;
  AsSoonAsPossible: SocialSecurityComparisonModel;
  AtRetirement: SocialSecurityComparisonModel;
  AtFra: SocialSecurityComparisonModel;
  AtAge70: SocialSecurityComparisonModel;
  PrincipalName: string | null;
  SpouseName: string | null;
  HasSocialSecurityIncome: boolean;
  PrincipalIsCurrentlyReceivingBenefits: boolean;
  SpouseIsCurrentlyReceivingBenefits: boolean;
}

const fetchSocialSecurityComparison = async (
  clientId: number,
  fpId: string,
): Promise<SocialSecurityComparisonDTO> => {
  return authFetch(
    urlWithParams('/Consumer/OptimizeSocialSecurity/GetSocialSecurityComparison', {
      clientId,
      fpId,
    }),
  );
};

export interface Params {
  clientId: number;
  fpId: string;
  enabled: boolean;
}

export const useSocialSecurityComparisonQuery = ({ clientId, fpId, enabled }: Params) => {
  return useQuery(
    queryKeys.socialSecurityComparison(clientId, fpId),
    () => fetchSocialSecurityComparison(clientId, fpId),
    { enabled },
  );
};
